<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 9.6875H3H4V7.8125H3H2V9.6875ZM3 7H2V6V5.9375V5H3H4V5.9375H3L3 6V7ZM5 5H7V6V7H5V6V5ZM2 19V18H3V19V19.0625H4V20H3H2V19.0625V19ZM22 6V7H21V6V5.9375H20V5H21H22V5.9375V6ZM9 6V5H11V6V7H9V6ZM13 6V5H15V6V7H13V6ZM17 6V5H19V6V7H17V6ZM21 7.8125H22V9.6875H21H20V7.8125H21ZM21 11.5625H22V12H20V11.5625H21ZM14 18H13V19V20H14V18ZM11 19V20H9V19V18H11V19ZM7 19V20H5V19V18H7V19ZM3 17.1875H2V15.3125H3H4V17.1875H3ZM3 13.4375H2V11.5625H3H4V13.4375H3Z"
      fill="#052E37"
    />
    <path
      d="M16.75 24C16.55 24 16.375 23.925 16.225 23.775C16.075 23.625 16 23.45 16 23.25V14.75C16 14.55 16.075 14.375 16.225 14.225C16.375 14.075 16.55 14 16.75 14H21.2625L24 16.7375V23.25C24 23.45 23.925 23.625 23.775 23.775C23.625 23.925 23.45 24 23.25 24H16.75ZM20.8875 17.075V14.75H16.75V23.25H23.25V17.075H20.8875ZM16.75 14.75V17.075V14.75V23.25V14.75Z"
      fill="#052E37"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ZamgRectangleTemplate',
});
</script>
